import { render, staticRenderFns } from "./RefTagsListFilters.vue?vue&type=template&id=74de3484"
import script from "./RefTagsListFilters.vue?vue&type=script&lang=js"
export * from "./RefTagsListFilters.vue?vue&type=script&lang=js"
import style0 from "./RefTagsListFilters.vue?vue&type=style&index=0&id=74de3484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports